import { deserialize, object, serializable } from 'serializr';
import { User } from './user.model';
import { PageObject } from './page-object.model';
import { Base } from './base.model';
import { Project } from './project.model';
import { Role } from './role.model';

export class UserProjectMapping extends Base implements PageObject {
  @serializable
  public userId: number;
  @serializable
  public projectId: number;
  @serializable
  public roleId: number;
  @serializable(object(User))
  public user: User;
  @serializable(object(Project))
  public project: Project;
  @serializable(object(Role))
  public role: Role;
  @serializable
  public canDestroy: boolean;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(UserProjectMapping, input));
  }
}
